type AssetImport = string | {src: string}

/**
 * FIXME: Добиться единой сборки
 * Унифицирует получение URL ассета для разных сборщиков
 */
export function getAssetUrl(asset: AssetImport): string | undefined {
  if (typeof asset === 'string') return asset
  if ('src' in asset) return asset.src
  return undefined
}
